import { string, object, array } from 'yup'

const VALID_REGEX = /^[\d\sA-Za-z]+$/

const addTopicSchema = object({
  name: string().required('Please enter a valid topic name'),
  primaryKeyword: string().matches(VALID_REGEX, 'Please enter a valid keyword'),
  secondaryKeywords: array()
    .of(string())
    .test(
      'isValidSecondaryKeyword',
      param => {
        const invalidKeyword = param.value.find(
          (keyword: string) => !VALID_REGEX.test(keyword)
        )
        return `Please enter a valid keyword: ${invalidKeyword}`
      },
      values => !values?.some(value => value && !VALID_REGEX.test(value))
    ),
})

export default addTopicSchema
